import { useScrollFadeIn, staggerStyle } from "@/hooks/useScrollFadeIn";

export default function AboutSection() {
  const { ref: headRef, style: headStyle } = useScrollFadeIn<HTMLDivElement>({ delay: 0 });
  const { ref: imgRef, style: imgStyle } = useScrollFadeIn<HTMLDivElement>({ delay: 0.1 });
  const { ref: textRef, style: textStyle } = useScrollFadeIn<HTMLDivElement>({ delay: 0.2 });

  return (
    <section id="about" className="py-24 md:py-16 bg-rose-200">
      <div className="max-w-5xl mx-auto px-5 md:px-10">
        <div ref={headRef} style={headStyle} className="text-center mb-6 md:mb-10">
          <p className="text-xs md:text-sm tracking-[0.4em] text-rose-900 uppercase mb-2 md:mb-3">About</p>
          <h2
            className="font-en text-3xl md:text-4xl font-normal text-stone-800 tracking-widest"
          >
            Profile
          </h2>
          <div className="w-12 h-0.5 bg-rose-600 mx-auto mt-4 md:mt-5"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10 items-center">
          {/* Image */}
          <div ref={imgRef} style={imgStyle} className="relative inline-block w-full">
            {/* モバイル：横長トリミング（中央） */}
            <div className="block md:hidden w-full h-80 overflow-hidden bg-stone-100">
              <img
                src="https://static.readdy.ai/image/7c1ae4d4fec6bc38be3e9701ed9ec762/3a6a19628368f9ee7f281b98b0bdc7a2.png"
                alt="むぎ茶"
                className="w-full h-full object-cover object-center"
              />
            </div>
            {/* デスクトップ：縦長 */}
            <div className="hidden md:block overflow-hidden bg-stone-100" style={{ height: '480px' }}>
              <img
                src="https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/a1e4ad32-910b-4782-ab4d-1719d8636e53_-6.png?v=52dddeb7267607e385805c2422a3acd6"
                alt="むぎ茶"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="block md:hidden absolute -top-3 -left-3 -right-3 -bottom-3 border border-rose-600 pointer-events-none"></div>
            <div className="hidden md:block absolute border border-rose-600 pointer-events-none" style={{ top: '-16px', left: '-16px', right: '-16px', bottom: '-16px' }}></div>
          </div>

          {/* Text */}
          <div ref={textRef} style={textStyle} className="pt-2 md:pt-0">
            <h3
              className="text-xl md:text-2xl font-light text-stone-800 tracking-widest mb-3 md:mb-4"
            >
              むぎ茶
            </h3>
            <div className="space-y-3 text-[15px] text-stone-700 leading-relaxed">
              <p>幼少期からの変態性が高じてSMの世界へ<br /></p>
              <div className="w-8 h-px bg-stone-300 my-3"></div>
              <div className="space-y-2.5 pl-4">
                <div className="flex items-start gap-3">
                  <span className="w-1.5 h-1.5 rounded-full bg-rose-600 mt-2 flex-shrink-0"></span>
                  <p>「S＆Mスナイパー」エッセイ連載</p>
                </div>
                <div className="flex items-start gap-3">
                  <span className="w-1.5 h-1.5 rounded-full bg-rose-600 mt-2 flex-shrink-0"></span>
                  <p className="whitespace-nowrap">SMクラブ・M性感７年以上経験</p>
                </div>
                <div className="flex items-start gap-3">
                  <span className="w-1.5 h-1.5 rounded-full bg-rose-600 mt-2 flex-shrink-0"></span>
                  <p>月に一度お仕置きBARのママ</p>
                </div>
                <div className="flex items-start gap-3">
                  <span className="w-1.5 h-1.5 rounded-full bg-rose-600 mt-2 flex-shrink-0"></span>
                  <p>えっちなこと、SM、フェチが大好き</p>
                </div>
              </div>
              <div className="w-8 h-px bg-stone-300 my-2 md:my-3"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
